import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { BusinessRelationshipMultipleItem, BusinessRelationshipResponse } from 'types/BusinessRelationship';

export const useGetRelatedBrs = (id: string | string[], usedInBr: boolean) => {
  return useQuery<BusinessRelationshipResponse[] | BusinessRelationshipMultipleItem[], AxiosError>({
    queryKey: ['useGetRelatedBrs', id],
    queryFn: () => {
      if (Array.isArray(id)) {
        const list = id.filter((item) => item !== 'other');
        // Array → call API that accepts multiple partner UIDs
        return contactNoteDialogService.getRelatedBRForMultiplePartners(list);
      } else {
        // String → call API that accepts a single UID
        return contactNoteDialogService.getRelatedBrs(id);
      }
    },

    enabled: !usedInBr,
  });
};
